import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/styles";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";

const useStyles = makeStyles((theme) => ({
  topActions: {
    // height: "50px",
    background: theme.app.background[1],
    color: theme.app.labelColor,
    display: "flex",
    alignItems: "center",
    padding: "0 16px",
    borderBottom: `1px solid ${theme.app.borderColor}`,
  },
  group: { flexDirection: "row" },
  labelText: {
    fontSize: "0.875rem",
    color: theme.app.labelColor,
  },
}));

const TopActions = (props) => {
  const {
    anyConfirmed,
    anyQueued,
    anyCancelled,
    selected,
    setSelected,
    language,
    bookings,
  } = props;
  const classes = useStyles();

  useEffect(() => {
    if (bookings.length < 1) return;
    if (anyConfirmed && !selected) {
      return setSelected("confirmed");
    }
    if (anyQueued && !selected) {
      return setSelected("queued");
    }
    if (!selected) {
      return setSelected("cancelled");
    }
  }, [anyConfirmed, anyCancelled, anyQueued, selected, setSelected, bookings]);
  return (
    <div className={classes.topActions}>
      <RadioGroup
        value={selected || "confirmed"}
        onChange={(e) => setSelected(e.target.value)}
        className={classes.group}
      >
        <FormControlLabel
          label={language.confirmed}
          value="confirmed"
          control={<Radio />}
          disabled={!anyConfirmed}
          classes={{ label: classes.labelText }}
        />
        <FormControlLabel
          label={language.queued}
          value="queued"
          disabled={!anyQueued}
          control={<Radio />}
          classes={{ label: classes.labelText }}
        />
        <FormControlLabel
          label={language.cancelled}
          value="cancelled"
          disabled={!anyCancelled}
          control={<Radio />}
          classes={{ label: classes.labelText }}
        />
      </RadioGroup>
    </div>
  );
};

export default TopActions;
